import { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/vehicleonboard/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import Layouts from "../../layouts/layouts";
import Add_data_modal from "../../components/vehicleonboard/update_data_modal";
import VehicleonboardDetailModal from "../../components/vehicleonboard/Vehicleonboard Details";

export default function Vehicleonboard() {
  const title = "Vehicle On-board Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [vehicleonboard, setVehicleonboard] = useState(0);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showVehicleonboardDetailModal, setShowVehicleonboardDetailModal] =
    useState(false);
  const [selectedVehicleonboard, setSelectedVehicleonboard] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  const columns = [
    {
      name: <b>Vehicle Number</b>,
      selector: (row) => row.temp_number,
      sortable: true,
    },
    {
      name: <b>OnBoard Date</b>,
      selector: (row) => formatDate(row.date),
      sortable: true,
    },
    {
      name: <b>Company</b>,
      selector: (row) => row.vehicle_type?.company || "N/A",
      sortable: true,
      cell: (row) => (
        <div style={{ whiteSpace: "nowrap", overflow: "visible" }}>
          {row.vehicle_type?.company || "N/A"}
        </div>
      ),
    },
    // {
    //   name: <b>Vehicle Type</b>,
    //   selector: (row) => row.vehicle_type,
    //   sortable: true,
    // },
    {
      name: <b>Leasing Partner</b>,
      selector: (row) => row.leasing_partner,
      sortable: true,
    },
    {
      name: <b>Last Service Type</b>,
      selector: (row) => row.lastServiceType || "-",
      sortable: true,
    },
    {
      name: <b>Location</b>,
      selector: (row) => row.location,
      sortable: true,
    },
    {
      name: <b>Client</b>,
      selector: (row) => (row.client ? row.client.name : "-"),
      sortable: true,
    },
    {
      name: <b>Handover Supervisor</b>,
      selector: (row) =>
        row.handover_supervisor ? row.handover_supervisor.name : "-",
      sortable: true,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => viewVehicleonboard(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
          <button
            onClick={() => setUpdateStoreBtn(row)}
            className="btn btn-info btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
          <button
            onClick={() => delete_row(row)}
            className="btn btn-danger btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      ),
    },
  ];

  const fetchData = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/vehicle-onboarding`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (Array.isArray(response.data.data)) {
        setApiState(response.data.data);
      } else {
        console.error("Unexpected data format from API", response.data);
      }
      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const viewVehicleonboard = (vehicleonboard) => {
    setSelectedVehicleonboard(vehicleonboard);
    setShowVehicleonboardDetailModal(true);
  };
  const updateVehicleonboard = (updatedVehicleonboard) => {
    setApiState((prev) =>
      prev.map((vehicleonboard) =>
        vehicleonboard._id === updatedVehicleonboard._id
          ? updatedVehicleonboard
          : vehicleonboard,
      ),
    );
  };

  const delete_row = (row) => {
    Swal.fire({
      icon: "warning",
      title: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        axios
          .delete(
            `${process.env.REACT_APP_BASE_URL}/api/v4/vehicle-onboarding/${row._id}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then(() => {
            Swal.fire(
              "Deleted!",
              "Vehicle on Board has been deleted.",
              "success",
            );
            fetchData(currentPage);
          })
          .catch((error) => {
            Swal.fire(
              "Error!",
              "Vehicle on Board could not be deleted.",
              "error",
            );
            console.error("Error deleting Vehicle on Board:", error);
          });
      }
    });
  };
  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const exportToExcel = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        console.error("No token found");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/vehicle-onboarding`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const allVehicles = response.data.data || [];

      if (allVehicles.length === 0) {
        Swal.fire(
          "No Data",
          "There are no vehicle onboarding records to export.",
          "info",
        );
        return;
      }

      const transformedData = allVehicles.map((vehicle) => ({
        "Vehicle Number": vehicle.temp_number || "-",

        "On-Board Date": vehicle.date ? formatDate(vehicle.date) : "N/A",

        Company: vehicle.vehicle_type?.company || "N/A",

        "Vehicle Type": vehicle.vehicle_type?.vehicle_type || "N/A",

        Category: vehicle.vehicle_type?.vehicleCategory || "N/A",

        Feet: vehicle.vehicle_type?.feet || "N/A",

        Size: vehicle.size || "-",

        "Leasing Partner": vehicle.leasing_partner || "-",

        Location: vehicle.location || "-",

        Client: vehicle.client?.name || "-",

        "Handover Supervisor": vehicle.handover_supervisor?.name || "-",

        "Current KM": vehicle.currentKm ?? 0,

        "Service Completed": vehicle.serviceCompleted ? "Yes" : "No",

        "Last Service KM": vehicle.lastServiceKm ?? 0,

        "Last Service Date": vehicle.lastServiceDate
          ? formatDate(vehicle.lastServiceDate)
          : "N/A",

        "Last Service Type": vehicle.lastServiceType || "-",

        "Additional Things": vehicle.additionalThings?.length
          ? vehicle.additionalThings
              .map((item) => item.thing?.name || "-")
              .join(", ")
          : "-",

        "Additional Thing Photos": vehicle.additionalThings?.length
          ? vehicle.additionalThings
              .filter((item) => item.photo)
              .map((item) => item.photo)
              .join(", ")
          : "-",

        Comments: vehicle.comments || "-",

        "Created Date": vehicle.createdAt
          ? formatDate(vehicle.createdAt)
          : "N/A",

        "Updated Date": vehicle.updatedAt
          ? formatDate(vehicle.updatedAt)
          : "N/A",
      }));

      const worksheet = XLSX.utils.json_to_sheet(transformedData);

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Vehicle Onboarding");

      XLSX.writeFile(workbook, "VehicleOnboardingData.xlsx");
    } catch (error) {
      console.error("Export error:", error);

      Swal.fire(
        "Error!",
        "Vehicle onboarding data could not be exported.",
        "error",
      );
    }
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateVehicleonboard={updateVehicleonboard}
      />
      <VehicleonboardDetailModal
        show={showVehicleonboardDetailModal}
        onHide={() => setShowVehicleonboardDetailModal(false)}
        vehicleonboard={selectedVehicleonboard}
      />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>

                <div>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm me-2"
                  >
                    Export to Excel
                  </button>

                  <Link to="/create-vehicleonboard">
                    <div className="btn btn-info btn-sm text-white">
                      Add Vehicle-Onboard
                    </div>
                  </Link>
                </div>
              </div>
              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="vehicle"
                    title_btn={true}
                    title="Vehicle Onboard List"
                    apidata={apistate}
                    columns={apicol}
                    setVehicleonboard={setVehicleonboard}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
